export type GeometryRect = {
  left: number;
  right: number;
  top: number;
  bottom: number;
};

/**
 * Whether two axis-aligned rects overlap. `tolerance` expands the test
 * rect on every side, so rects that fall a few pixels short of touching
 * (sub-pixel rendering, borders) still count as intersecting.
 */
export function isIntersecting(
  targetRect: GeometryRect,
  destinationRect: GeometryRect,
  { tolerance = 0 }: { tolerance?: number } = {},
): boolean {
  return (
    targetRect.left <= destinationRect.right + tolerance &&
    targetRect.right >= destinationRect.left - tolerance &&
    targetRect.top <= destinationRect.bottom + tolerance &&
    targetRect.bottom >= destinationRect.top - tolerance
  );
}

/**
 * Whether `targetRect` wholly contains `testRect`.
 */
export function isRectEnclosing(
  targetRect: GeometryRect,
  testRect: GeometryRect,
): boolean {
  return (
    targetRect.left <= testRect.left &&
    targetRect.right >= testRect.right &&
    targetRect.top <= testRect.top &&
    targetRect.bottom >= testRect.bottom
  );
}
